export default __webpack_public_path__ + "static/media/radio-di-full.3c033e44.svg";